import React from 'react';
import {ReactComponent as CititizensPoweredBySvg} from 'resources/logos/JA_Citizens_PoweredBy.svg';

export function CititizensPoweredBy() {
  return <CititizensPoweredBySvg />;
}
